import {
  getJsonAsync
} from 'shared/actions';
import {checkAuth} from 'shared/auth/actions';
import {
  hideNavigationIcon,
  displayNavigationIcon,
  displayNavigation,
  hideNavigation,
  setNavigationActive
} from 'shared/navigationBar/actionTypes';
import {
  setTitle,
  setSubTitle
} from 'shared/topBanner/actionTypes';
import {setTournament} from './actionTypes';
import {
  retrieveTournaments,
  retrieveCreateTournamentPermission,
  retrieveGroupName
} from './tournamentList/actions';
import {
  setupTournamentForm,
  retrieveCards,
  retrieveTags,
  retrieveTimeZones,
  retrieveLocations,
  retrieveThemes,
  retrieveDataExportOptions ,
  retrieveSelectedExportOption,
  retrieveStripeAccounts,
  retrieveSelectedCard,
  retrieveSelectedStripeAccount,
  clearPreviousSessionVariables
} from './general/actions';
import {
  setupTournamentComForm 
} from './communications/actions';
import {
  retrieveManagers,
  retrieveAdministrators,
  setupTournamentPermissionsForm 
} from './permissions/actions';
import {
  retrieveVirtualEvents,
  retrieveEvents
} from './events/actions';
import {loadSquadCalendar} from './squads/actions';
import {
  retrieveDivisionsEvents,
  retrieveDivisionVirtualEvents
} from './divisions/actions';
import {retrieveSquadsByTournament} from  './capacity/actions';
import {
  retrieveInactiveFees,
  retrieveActiveFees,
  retrieveEventTypes
} from './fees/actions';
import {
  retrieveActiveBundles,
  retrieveBundlingRuleEvents
} from './restrictions/bundles/actions';
import {
  retrieveAvailableStatuses, 
  retrieveExportSystemName, 
  setExportStatusData
} from './status/actions';
import {
  setTournamentStatus,
  setTournamentHasPendingChanges
} from './status/actionTypes';
import {
  retrieveRestriction
} from './restrictions/actions';

import { animateScroll } from 'react-scroll';

export const handleRouteLeave = () => dispatch => {
  if (!window.location.pathname.startsWith('/tournament/update')) {
    dispatch(hideNavigation());
    dispatch(setTitle(''));
    dispatch(setSubTitle(''));
  }
};

export const handleSetupHomeRouteEnter = (nextState, replace, callback) =>
  dispatch => dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    dispatch(retrieveTournaments());
    dispatch(retrieveCreateTournamentPermission());
    dispatch(setTitle('All Tournaments'));
    dispatch(retrieveGroupName());
  })
  .catch(() => {});

export const handleSetupCreateRouteEnter = (nextState, replace, callback) =>
  dispatch => dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    dispatch(setTitle('Create New Tournament'));
    dispatch(retrieveCards());
    dispatch(retrieveDataExportOptions());
    dispatch(retrieveStripeAccounts());
    dispatch(retrieveTags());
    dispatch(retrieveThemes());
    dispatch(retrieveTimeZones());
    dispatch(clearPreviousSessionVariables());
    dispatch(retrieveGroupName());
  })
  .catch(() => {});

  export const handleSetupUpdateRouteEnter = (nextState, replace, callback) =>
  (dispatch) => dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    const tournamentId = nextState.params.tournamentId;

    dispatch(setNavigationActions('general', tournamentId));
    dispatch(loadTournament(tournamentId)).then((data) => {
      dispatch(setupTournamentForm());
      dispatch(setTournamentSubtitle());
      dispatch(retrieveSelectedCard(data.cardId));
      dispatch(retrieveSelectedExportOption(data.exportId));
      dispatch(retrieveSelectedStripeAccount(data.stripeAccountId));
      dispatch(retrieveGroupName());
    });
    dispatch(retrieveCards());
    dispatch(retrieveDataExportOptions());
    dispatch(retrieveLocations(tournamentId));
    dispatch(retrieveStripeAccounts());
    dispatch(retrieveTags(tournamentId));
    dispatch(retrieveThemes());
    dispatch(retrieveTimeZones());
  })
  .catch(() => {});
  
export const handleUpdateCommunicationRouteEnter = (nextState, replace, callback) =>
(dispatch) => dispatch(checkAuth(nextState, replace, callback))
.then(() => {
  const tournamentId = nextState.params.tournamentId;

  dispatch(setNavigationActions('communication', tournamentId));
  dispatch(loadTournament(tournamentId)).then( () => {
    dispatch(setupTournamentComForm());
    dispatch(setTournamentSubtitle());
  });
})
.catch(() => {});

export const handleSetupPermissionsRouteEnter = (nextState, replace, callback) =>
(dispatch) => dispatch(checkAuth(nextState, replace, callback))
.then(() => {
  const tournamentId = nextState.params.tournamentId;

  dispatch(setNavigationActions('permissions', tournamentId));
  dispatch(loadTournament(tournamentId)).then( () => {
    dispatch(setupTournamentPermissionsForm());
    dispatch(setTournamentSubtitle());
  });
  dispatch(retrieveManagers(tournamentId));
  dispatch(retrieveAdministrators(tournamentId));
})
.catch(() => {});

export const handleSetupEventsRouteEnter = (nextState, replace, callback) =>
  dispatch => dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    const tournamentId = nextState.params.tournamentId;

    dispatch(setNavigationActions('events', tournamentId));
    dispatch(loadTournament(tournamentId)).then(() => {
      dispatch(setTournamentSubtitle());
    });
    dispatch(retrieveEvents(tournamentId));
    dispatch(retrieveVirtualEvents(tournamentId));
  })
  .catch(() => {});

export const handleSetupSquadsRouteEnter = (nextState, replace, callback) =>
  dispatch => dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    const tournamentId = nextState.params.tournamentId;

    dispatch(setNavigationActions('squads', tournamentId));
    dispatch(loadTournament(tournamentId)).then( () => {
      dispatch(loadSquadCalendar(tournamentId));
      dispatch(setTournamentSubtitle());
    });
  })
  .catch(() => {});

export const handleSetupDivisionsRouteEnter = (nextState, replace, callback) =>
  dispatch => dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    const tournamentId = nextState.params.tournamentId;

    dispatch(setNavigationActions('divisions', tournamentId));
    dispatch(loadTournament(tournamentId)).then(() => {
      dispatch(setTournamentSubtitle());
    });
    dispatch(retrieveDivisionsEvents(tournamentId));
    dispatch(retrieveDivisionVirtualEvents(tournamentId));
  })
  .catch(() => {});

export const handleSetupCapacityRouteEnter = (nextState, replace, callback) =>
  dispatch => dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    const tournamentId = nextState.params.tournamentId;

    dispatch(setNavigationActions('capacity', tournamentId));
    dispatch(loadTournament(tournamentId)).then(() => {
      dispatch(setTournamentSubtitle());
    });
    dispatch(retrieveSquadsByTournament(tournamentId));
  })
  .catch(() => {});

export const handleSetupFeesRouteEnter = (nextState, replace, callback) =>
  dispatch => dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    const tournamentId = nextState.params.tournamentId;

    dispatch(setNavigationActions('fees', tournamentId));
    dispatch(loadTournament(tournamentId)).then(() => {
      dispatch(setTournamentSubtitle());
    });
    dispatch(retrieveActiveFees(tournamentId));
    dispatch(retrieveInactiveFees(tournamentId));
    dispatch(retrieveEventTypes(tournamentId));
  })
  .catch(() => {});

export const handleSetupRestrictionsRouteEnter  = (nextState, replace, callback) =>
  dispatch => dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    const tournamentId = nextState.params.tournamentId;

    dispatch(setNavigationActions('restrictions', tournamentId));
    dispatch(loadTournament(tournamentId)).then(() => {
      dispatch(setTournamentSubtitle());
    });
    dispatch(retrieveRestriction(tournamentId)); 
    dispatch(retrieveActiveBundles(tournamentId));
    dispatch(retrieveBundlingRuleEvents(tournamentId));
  })
  .catch(() => {});

export const handleSetupStatusRouteEnter = (nextState, replace, callback) =>
  dispatch => dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    const tournamentId = nextState.params.tournamentId;

    dispatch(setNavigationActions('status', tournamentId));
    dispatch(loadTournament(tournamentId)).then((data) => {
      dispatch(setTournamentSubtitle());
      dispatch(retrieveExportSystemName());
      dispatch(setExportStatusData(data));
    });
    dispatch(retrieveAvailableStatuses());    
  })
  .catch(() => {});

export const setNavigationActions = (active, tournamentId) => dispatch => {
  dispatch(displayNavigation([
    {
      key: 'tournamentList',
      to: `tournament`,
      navOrigin: true
    },
    {
      key: 'general',
      label: 'General',
      active: true,
      to: `tournament/update/${tournamentId}`
    },
    {
      key: 'communication',
      label: 'Communication',
      to: `tournament/update/${tournamentId}/communication`
    },
    {
      key: 'permissions',
      label: 'Permissions',
      to: `tournament/update/${tournamentId}/permissions`
    },
    {
      key: 'events',
      label: 'Events',
      to: `tournament/update/${tournamentId}/events`
    },
    {
      key: 'squads',
      label: 'Squads',
      to: `tournament/update/${tournamentId}/squads`
    },
    {
      key: 'divisions',
      label: 'Divisions',
      to: `tournament/update/${tournamentId}/divisions`
    },
    {
      key: 'capacity',
      label: 'Capacity',
      to: `tournament/update/${tournamentId}/capacity`
    },
    {
      key: 'fees',
      label: 'Fees',
      to: `tournament/update/${tournamentId}/fees`
    }, 
    {
      key: 'restrictions',
      label: 'Restrictions',
      to: `tournament/update/${tournamentId}/restrictions`
    },
    {
      key: 'status',
      label: 'Status',
      to: `tournament/update/${tournamentId}/status`
    }
  ]));
  dispatch(setNavigationActive(active));
};

export const loadTournament = id => dispatch => new Promise( resolve => {
  dispatch(getJsonAsync(`setup/tournament/${id}`))
  .then(data => {
    dispatch(setTitle(data.name));
    dispatch(setTournamentStatus(data.statusDisplayName));
    dispatch(setTournamentHasPendingChanges(data.hasPendingChanges));
    dispatch(setTournament(data));
    if(data.hasPendingChanges) {
      dispatch(displayNavigationIcon('status', 'fa-exclamation', 'text-danger'));
    } else {
      dispatch(hideNavigationIcon('status'));
    }
    resolve(data);
  });
});

export default function scrollToFirstError(errors) {
    const errorFields = getErrorFieldNames(errors);

    for (let i = 0; i < errorFields.length; i++) {
        const fieldName = `${errorFields[i]}`;

        const elements = document.querySelectorAll(`[name="${fieldName}"]`);

        if (elements.length) {
          if (elements[0].type === "hidden") {
            animateScroll.scrollTo(elements[0].parentNode.offsetTop); // scroll to field in error, using offset from parent.
          }
          else if (elements[0].offsetParent.offsetParent.tagName === 'BODY') {
            animateScroll.scrollTo(elements[0].offsetTop + elements[0].parentNode.offsetHeight); // scroll to field in error, relative to body.
          }
          else {    // for dynamic displayed fields: scroll to field in error, relative to offset of parent.
            animateScroll.scrollTo(elements[0].offsetParent.offsetTop + elements[0].parentNode.offsetHeight);
          }
          break;
        }
    }
}

function getErrorFieldNames(obj, name = '') {
    const errorArr = [];

    errorArr.push(Object.keys(obj).map((key) => {
        const next = obj[key];

        if (next) {
            if (typeof next === 'string') {
                return name + key;
            }
            // Keep looking
            if (next.map) {
                errorArr.push(next.map((item, index) => getErrorFieldNames(item, `${name}${key}[${index}].`)).filter(o => o));
            }
        }
        return null;
    }).filter(o => o));
    return flatten(errorArr);
}

function flatten (arr) {
    return arr.reduce((flat, toFlatten) => flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten), []);
}

const setTournamentSubtitle = () => (dispatch, getState) => {
  const groupName = getState().shared.auth.groupName;
  const tournamentInfo = getState().tournament.base.tournamentInfo;

  if (tournamentInfo.readOnly) {
    dispatch(setSubTitle('Tournament has ended. Settings cannot be edited.'));
  } else if (groupName) {
    dispatch(setSubTitle('Update Tournament for ' + groupName));
  } else {
    dispatch(setSubTitle('Update Tournament'));
  }
};

const setManageTournamentSubtitle = () => (dispatch, getState) => {
  const groupName = getState().shared.auth.groupName;
  
  if (groupName) {
    dispatch(setSubTitle('for ' + groupName));
  } else {
    dispatch(setSubTitle(''));
  }
};


// WEBPACK FOOTER //
// ./src/features/tournament/actions.js